import ResetAgentChatStatus from "components/ResetAgentChatStatus";
import NoPermission from "pages/no-permission/NoPermission";
import { checkIsAllowedPath } from "permissions";
import { Component } from "react";
import { connect } from "react-redux";
import { renderRoutes } from "react-router-config";
import { Redirect, Route, Switch } from "react-router-dom";

import Drawer from "./../components/Drawer";
import Notification from "./../components/Notification";
import Snackbar from "./../components/Snackbar";

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { route, user } = this.props;

    const noPermission = !checkIsAllowedPath(user.profile?.user?.role);
    if (noPermission) return <NoPermission />;

    return (
      <Drawer name={this.props.route.name}>
        <Snackbar />
        <Notification />
        <Switch>
          {user.agentStatus?.status && (
            <Route exact path={process.env.REACT_APP_PATH}>
              <Redirect
                to={`${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`}
              />
            </Route>
          )}
          {route ? renderRoutes(route.routes) : this.props.children}
        </Switch>
        {(user.profile?.user?.role === "telephonist.service" ||
          user.profile?.user?.role === "Supervisor") && (
          <ResetAgentChatStatus />
        )}
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.init,
});

export default connect(mapStateToProps)(Admin);
